<template>
    <div class="land-info">
        <div class="container">
            <div class="land-info-column-container">
                <div class="info-desc">
                    <p v-html="salesCard.shablon_section_info_zakon"></p>
                    <p v-html="salesCard.shablon_section_info_desc"></p>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'sale-land-info',
        components: {
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-info.scss';
    @import '@/styles/components/sales/respond/land-info-respond.scss';
</style>